/**
 * WebMCP Tools — BM Maligator (bmmaligator.com)
 * Registers AI-agent-callable tools for product discovery, order tracking, and customer service.
 * Classification: Store Asset | Brand: BM Maligator
 * Deployed via: Shopify theme.liquid <script> tag or asset file
 */
(function() {
  'use strict';

  if (!('modelContext' in navigator)) return;

  var STORE_NAME = 'BM Maligator';
  var STORE_DESC = 'Premium Belgian Malinois apparel and gear. Elite Working Line collection featuring tactical K9, Mononofu samurai, and bushido designs.';

  // -------------------------------------------------------
  // 1. SEARCH PRODUCTS
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'search_products',
    description: 'Search BM Maligator products by keyword. Returns matching products with title, price, image, and URL.',
    inputSchema: {
      type: 'object',
      properties: {
        query: {
          type: 'string',
          description: 'Search keyword (e.g., "hoodie", "samurai", "tactical")'
        }
      },
      required: ['query']
    },
    execute: async function(params) {
      try {
        var response = await fetch('/search/suggest.json?q=' + encodeURIComponent(params.query) + '&resources[type]=product&resources[limit]=10');
        var data = await response.json();
        var products = data.resources && data.resources.results && data.resources.results.products || [];

        if (!products.length) {
          return { content: [{ type: 'text', text: 'No products found for "' + params.query + '" at ' + STORE_NAME + '.' }] };
        }

        var results = products.map(function(p) {
          return {
            title: p.title,
            price: p.price,
            url: 'https://bmmaligator.com' + p.url,
            image: p.image
          };
        });

        return {
          content: [{
            type: 'text',
            text: JSON.stringify({ store: STORE_NAME, query: params.query, results: results }, null, 2)
          }]
        };
      } catch (e) {
        return { content: [{ type: 'text', text: 'Search failed. Please try again.' }] };
      }
    }
  });

  // -------------------------------------------------------
  // 2. GET PRODUCT DETAILS
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'get_product_details',
    description: 'Get full details for a specific BM Maligator product including all variants, sizes, price, description, and images.',
    inputSchema: {
      type: 'object',
      properties: {
        handle: {
          type: 'string',
          description: 'Product handle/slug (e.g., "bm-maligator-tactical-k9-premium-tee")'
        }
      },
      required: ['handle']
    },
    execute: async function(params) {
      try {
        var response = await fetch('/products/' + encodeURIComponent(params.handle) + '.json');
        var data = await response.json();
        var p = data.product;

        var details = {
          title: p.title,
          description: p.body_html ? p.body_html.replace(/<[^>]+>/g, '') : '',
          price: p.variants[0] ? p.variants[0].price : 'N/A',
          available: p.variants.some(function(v) { return v.available; }),
          sizes: p.variants.map(function(v) { return { size: v.title, available: v.available, price: v.price }; }),
          images: p.images.map(function(img) { return img.src; }),
          url: 'https://bmmaligator.com/products/' + p.handle,
          tags: p.tags
        };

        return {
          content: [{
            type: 'text',
            text: JSON.stringify(details, null, 2)
          }]
        };
      } catch (e) {
        return { content: [{ type: 'text', text: 'Product not found. Check the handle and try again.' }] };
      }
    }
  });

  // -------------------------------------------------------
  // 3. GET COLLECTIONS
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'get_collections',
    description: 'List all BM Maligator product collections with product counts. Collections include Mononofu (samurai/Japanese) and Tactical Maligator (K9/military).',
    inputSchema: {
      type: 'object',
      properties: {}
    },
    execute: async function() {
      try {
        var collections = [
          { handle: 'mononofu', title: 'Mononofu', description: 'Samurai-inspired Belgian Malinois designs with Japanese aesthetic' },
          { handle: 'tactical-maligator', title: 'Tactical Maligator', description: 'Military/K9 tactical Belgian Malinois designs' }
        ];

        var results = [];
        for (var i = 0; i < collections.length; i++) {
          var c = collections[i];
          try {
            var response = await fetch('/collections/' + c.handle + '/products.json?limit=50');
            var data = await response.json();
            results.push({
              title: c.title,
              handle: c.handle,
              description: c.description,
              product_count: data.products ? data.products.length : 0,
              url: 'https://bmmaligator.com/collections/' + c.handle
            });
          } catch (e) {
            results.push({ title: c.title, handle: c.handle, product_count: 'unknown' });
          }
        }

        return {
          content: [{
            type: 'text',
            text: JSON.stringify({ store: STORE_NAME, collections: results }, null, 2)
          }]
        };
      } catch (e) {
        return { content: [{ type: 'text', text: 'Could not load collections.' }] };
      }
    }
  });

  // -------------------------------------------------------
  // 4. BROWSE COLLECTION PRODUCTS
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'browse_collection',
    description: 'Browse all products in a specific BM Maligator collection. Returns product list with titles, prices, and URLs.',
    inputSchema: {
      type: 'object',
      properties: {
        collection: {
          type: 'string',
          description: 'Collection handle: "mononofu" or "tactical-maligator"'
        }
      },
      required: ['collection']
    },
    execute: async function(params) {
      try {
        var response = await fetch('/collections/' + encodeURIComponent(params.collection) + '/products.json?limit=50');
        var data = await response.json();

        var products = (data.products || []).map(function(p) {
          return {
            title: p.title,
            price: p.variants[0] ? '$' + p.variants[0].price : 'N/A',
            url: 'https://bmmaligator.com/products/' + p.handle,
            image: p.images[0] ? p.images[0].src : null
          };
        });

        return {
          content: [{
            type: 'text',
            text: JSON.stringify({ collection: params.collection, products: products }, null, 2)
          }]
        };
      } catch (e) {
        return { content: [{ type: 'text', text: 'Collection not found.' }] };
      }
    }
  });

  // -------------------------------------------------------
  // 5. ADD TO CART
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'add_to_cart',
    description: 'Add a BM Maligator product to the shopping cart. Requires the variant ID and quantity.',
    inputSchema: {
      type: 'object',
      properties: {
        variant_id: {
          type: 'number',
          description: 'Shopify variant ID for the specific size/color'
        },
        quantity: {
          type: 'number',
          description: 'Quantity to add (default: 1)'
        }
      },
      required: ['variant_id']
    },
    execute: async function(params) {
      try {
        var response = await fetch('/cart/add.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: params.variant_id,
            quantity: params.quantity || 1
          })
        });
        var item = await response.json();

        return {
          content: [{
            type: 'text',
            text: 'Added to cart: ' + item.title + ' (Qty: ' + (params.quantity || 1) + '). View cart at https://bmmaligator.com/cart'
          }]
        };
      } catch (e) {
        return { content: [{ type: 'text', text: 'Could not add to cart. The variant may be sold out.' }] };
      }
    }
  });

  // -------------------------------------------------------
  // 6. GET CART
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'get_cart',
    description: 'View the current shopping cart contents at BM Maligator, including items, quantities, and total.',
    inputSchema: {
      type: 'object',
      properties: {}
    },
    execute: async function() {
      try {
        var response = await fetch('/cart.json');
        var cart = await response.json();

        var items = (cart.items || []).map(function(item) {
          return {
            title: item.title,
            variant: item.variant_title,
            quantity: item.quantity,
            price: '$' + (item.price / 100).toFixed(2),
            url: 'https://bmmaligator.com' + item.url
          };
        });

        return {
          content: [{
            type: 'text',
            text: JSON.stringify({
              item_count: cart.item_count,
              total: '$' + (cart.total_price / 100).toFixed(2),
              items: items,
              checkout_url: 'https://bmmaligator.com/checkout'
            }, null, 2)
          }]
        };
      } catch (e) {
        return { content: [{ type: 'text', text: 'Could not load cart.' }] };
      }
    }
  });

  // -------------------------------------------------------
  // 7. GET SIZING GUIDE
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'get_sizing_guide',
    description: 'Get the sizing chart for BM Maligator products. Covers t-shirts (American Apparel 1301) and hoodies (Gildan 18500).',
    inputSchema: {
      type: 'object',
      properties: {
        product_type: {
          type: 'string',
          description: '"tee" or "hoodie"'
        }
      },
      required: ['product_type']
    },
    execute: async function(params) {
      var charts = {
        tee: {
          brand: 'American Apparel 1301 Unisex Classic Tee',
          fit: 'Classic unisex fit',
          sizes: {
            S: { chest: '34-36"', length: '28"' },
            M: { chest: '38-40"', length: '29"' },
            L: { chest: '42-44"', length: '30"' },
            XL: { chest: '46-48"', length: '31"' },
            '2XL': { chest: '50-52"', length: '32"' },
            '3XL': { chest: '54-56"', length: '33"' }
          },
          tip: 'True to size. For a relaxed fit, size up one.'
        },
        hoodie: {
          brand: 'Gildan 18500 Heavy Blend Hoodie',
          fit: 'Classic fit, pre-shrunk',
          sizes: {
            S: { chest: '34-36"', length: '27"' },
            M: { chest: '38-40"', length: '28"' },
            L: { chest: '42-44"', length: '29"' },
            XL: { chest: '46-48"', length: '30"' },
            '2XL': { chest: '50-52"', length: '31"' },
            '3XL': { chest: '54-56"', length: '32"' }
          },
          tip: 'Runs slightly large. True to size for comfort fit, size down for slim.'
        }
      };

      var type = params.product_type === 'hoodie' ? 'hoodie' : 'tee';
      return {
        content: [{
          type: 'text',
          text: JSON.stringify(charts[type], null, 2)
        }]
      };
    }
  });

  // -------------------------------------------------------
  // 8. STORE INFO
  // -------------------------------------------------------
  navigator.modelContext.registerTool({
    name: 'get_store_info',
    description: 'Get information about BM Maligator store including brand story, shipping, returns, and contact.',
    inputSchema: {
      type: 'object',
      properties: {}
    },
    execute: async function() {
      return {
        content: [{
          type: 'text',
          text: JSON.stringify({
            name: STORE_NAME,
            tagline: 'Elite Working Line',
            description: STORE_DESC,
            url: 'https://bmmaligator.com',
            shipping: 'Free US shipping on all orders. International shipping available. Fulfilled by SwiftPOD via Printify. Ships in 3-7 business days.',
            returns: '30-day return policy on unworn/unwashed items.',
            collections: ['Mononofu (samurai/Japanese designs)', 'Tactical Maligator (K9/military designs)'],
            products: 'Premium t-shirts ($34.99) and hoodies ($54.99) in Black, S-3XL.',
            brand: 'Celebrating the Belgian Malinois - the ultimate working dog. Our designs blend Japanese bushido warrior culture with tactical K9 military heritage.'
          }, null, 2)
        }]
      };
    }
  });

  console.log('[WebMCP] BM Maligator: 8 tools registered');
})();
